/**
 * Country-region sub module
 */
module.exports = {
		
	/**
	 * initialize
	 */
	init: function(params) {
	
		// The regions object
	    var regionsMap = params.regionsMap;
		var numberOfCountries = params.numberOfCountries;
		var $contactAddress = $(params.regionField);
		var $country = $('#address\\.country');
		
		// Change the regions using this country code
		function changeRegion(countryCode) {
			
			// It could be that the region field is not a select if this isn't a CRM enabled locale
			// If that is the case then don't do anything here.
			if (!$contactAddress.is("select")) {
				return;
			}
			
			$contactAddress.empty();
	    	var optionsValues = '';
	        $.each(regionsMap[countryCode], function(i, region) {
	        	var $opt = $('<option value="' + region.code + '">' + region.name + '</option>');
	        	if(params.selectedRegion === region.code) {
	        		$opt.attr('selected', true);
	        	}
	        	$contactAddress.append($opt);
	        });
		}
		
		// Populate the region drop down with the current country
		changeRegion($country.val());
		
		// Select the correct region in the drop down
		if ($contactAddress.is("select")) {
			if (params.selectedRegion == '') {
				$contactAddress[0].selectedIndex = 0;
			}
			
			// When the country changes then update the regions by attaching a change listener to the country drop down
			$country.change(function(){
				changeRegion(this.value);
			});			
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/countryRegion.js
// module id = 59
// module chunks = 4 7